import type { AppState } from "store/types";

import { createMarkedSelector } from "./markedSelector";

const getEvaluatorLifecycle = (state: AppState) =>
  state.legacy.evaluations.lifecycle;

export const getHasEvaluated = createMarkedSelector("getHasEvaluated")(
  getEvaluatorLifecycle,
  (lifecycle) => !!lifecycle.lastCompleteTime,
);

export const getLastEvaluationStartTime = createMarkedSelector(
  "getLastEvaluationStartTime",
)(getEvaluatorLifecycle, (lifecycle) => lifecycle.lastStartTime);
